import { render, staticRenderFns } from "./llc-image-boxes.vue?vue&type=template&id=32a7c7ac&"
import script from "./llc-image-boxes.vue?vue&type=script&lang=js&"
export * from "./llc-image-boxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports